// Registers the service worker (app/views/pwa/service-worker.js): the offline page, and with the manifest
// what lets browsers offer to install the site. After the page has loaded, so it never competes with it.
export function registerServiceWorker () {
  if (!("serviceWorker" in navigator)) return

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch((error) => {
      console.error("Service worker registration failed", error)
    })
  }, { once: true })
}
